<template>
  <div class="flex h-full items-center">
    <a href="#" class="header__link header__link--primary hover:cursor-pointer" @click="zoomOut">
      <span class="text-xl">A-</span>
    </a>
    <a href="#" class="header__link header__link--primary hover:cursor-pointer" @click="zoomIn">
      <span class="text-2xl">A+</span>
    </a>
  </div>
</template>

<script>
export default {
  name: 'HeaderAcessibility',
  methods: {
    zoomIn(){
      if (this.zoomRate <= 1.3) {
        this.zoomRate = Number((this.zoomRate + 0.1).toFixed(1))
        document.body.style.zoom = this.zoomRate
        document.body.style.overflowX = 'scroll';
        document.body.style['-moz-transform'] = `scale(${this.zoomRate})`;
        document.body.style['-moz-transform-origin'] = '0 0';
      }
    },
    zoomOut(){
      if (this.zoomRate > 1) {
        this.zoomRate = Number((this.zoomRate - 0.1).toFixed(1));
        document.body.style.zoom = this.zoomRate
        document.body.style.overflowX = 'scroll';
        document.body.style['-moz-transform'] = `scale(${this.zoomRate})`;
        document.body.style['-moz-transform-origin'] = '0 0';
      } else {
        document.body.style.overflowX = 'auto';
      }
    },
  },
  data: () => ({
    zoomRate: 1,
  })
}
</script>
